import angular from 'angular'
import wskTaskCardComponent from './wskTaskCard.component'

export default angular
  .module('ellipsis.wskTaskCard', [])
  .component('wskTaskCard', wskTaskCardComponent)
